<template>
  <div>
    <div class="card mb-3">
      <div class="card-header">
        <h6 class="m-0 font-weight-bold text-primary">Jumlah ingin Verfikasi</h6>
      </div>
      <div class="card-body">
        {{ data.total_not_verified }}
      </div>
    </div>
    <div class="card mb-3">
      <div class="card-header">
        <h6 class="m-0 font-weight-bold text-primary">Jumlah helper yang terverifikasi</h6>
      </div>
      <div class="card-body">
        {{ data.total_agent }}
      </div>
    </div>
    <div class="card mb-3">
      <div class="card-header">
        <h6 class="m-0 font-weight-bold text-primary">Jumlah ingin Verfikasi</h6>
      </div>
      <div class="card-body">
        {{ data.total_verified }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props:[
    'data',
  ],
}
</script>
